import React from "react";
import {
    Header,
    List,
    Icon
} from "semantic-ui-react";

const Contact = () => (
    <>
        <Header as="h4">Contact</Header>
        <List>
            <List.Item><Icon name="mail" />first.last@helsinki.fi</List.Item>
            <List.Item><Icon name="mail" />first.last@cs.helsinki.fi</List.Item>
            <List.Item><Icon name="mail" />first.last@outlook.com</List.Item>
        </List>

        <Header as="h4">Building</Header>
        <List>
            <List.Item><Icon name="building" />Exactum, D223</List.Item>
            <List.Item><Icon name="map marker alternate" />Pietari Kalmin katu 5</List.Item>
            <List.Item><Icon name="mail outline" /> 00014 HELSINGIN YLIOPISTO</List.Item>
            <List.Item><Icon name="map pin" />Finland</List.Item>
        </List>
    </>
);

export default Contact;